import baseURL from "@/configs/baseUrl";
import Axios from "axios";
import router from "@/router/index";
import utils from "@/jslibs/utils";
const fetch = Axios.create({
    withCredentials: false,
    baseURL: process.env.NODE_ENV === "development" ? "/api" : baseURL,
    // timeout: 200000, // 设置超时时间
});
//请求发送前拦截，根据地址重新配置域名，再子路由请求时必须加/ 例如：请求 localhost:80/app/inset  fetch.get('/app/inset');
fetch.interceptors.request.use(
    function (config) {
        const token = utils.getCookie("authorization");
        // //后期改成从cookies中获取
        config.headers = {
            "X-Access-Token": token,
        };
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
fetch.interceptors.response.use(
    function (response) {
        if (response.data.code === 401 || response.data.code === 403) {
            vm.$message(response.data.message);
            setTimeout(() => {
                router.push("/login");
            }, 2000);
        } else {
			// 下载文件
            if (response.headers["content-disposition"] && response.headers["content-disposition"].indexOf("attachment") !== -1) {
				return response;
            }
            return response.data;
        }
    },
    function (error) {
        // 对响应错误做点什么
        const { status, data } = error.response;
        switch (status) {
            case 401:
            case 412:
                router.push("/login");
                vm.$message(data.error.message || "登录过期，请重新登录");
                break;
            case 403:
                vm.$message(data.error.message);
                return error.response;
            case 500:
                vm.$message.error("系统错误");
                break;
            default:
                vm.$message.error(data.error.message);
                return Promise.reject(data);
        }
    }
);

export default fetch;
